<template>
	<div class="userContact w-100">
		<!-- DESKTOP -->
		<template v-if="!isMobile">
			<div class="wrap" v-if="success == false">
				<div class="wrap-content">
					<div class="choose-contact-topic">
						<b-dropdown class="input-choose choose-type" no-flip>
							<template v-slot:button-content>
								<span>
									{{ topicItem ? $t(topicItem.name) : $t('Choose a contact topic') }}
									<ChevronDownIcon />
								</span>
							</template>
							<b-dropdown-item
								v-for="(data, index) in contactTopic"
								:key="index"
								@click="chooseContactTopic(data)"
								>{{ $t(data.name) }}</b-dropdown-item
							>
						</b-dropdown>
					</div>
					<div
						v-if="topicItem && topicItem.id == 1"
						class="wrap-report-problems"
					>
						<b-form-textarea
							:class="{
								'form-group-error': $v.contactParams.message.$error
							}"
							id="report-problems"
							:placeholder="$t('details')"
							rows="10"
							no-resize
							v-model="$v.contactParams.message.$model"
						></b-form-textarea>
						<div
							class="error"
							v-if="
								$v.contactParams.message.$error &&
									!$v.contactParams.message.required
							"
						>
							{{$t('Message is required')}}
						</div>
					</div>
					<div
						v-if="topicItem && topicItem.id == 2"
						class="wrap-advertisement-contact"
					>
						<div class="label-for-input">
							<div class="label">{{$t('Ways to contact you back')}}</div>
						</div>
						<b-dropdown no-flip
							class="input-choose"
							@click="showSidebar('choose-advertise')"
						>
							<template v-slot:button-content>
								<span>
									{{
										advertiseItem
											? $t(advertiseItem.name)
											: $t('Choose a way to contact you back')
									}}
									<ChevronDownIcon />
								</span>
							</template>
							<b-dropdown-item
								v-for="(data, index) in contactAdvertisements"
								:key="index"
								@click="chooseContactBack(data)"
								>{{ $t(data.name) }}</b-dropdown-item
							>
						</b-dropdown>
						<div
							v-if="advertiseItem && advertiseItem.id == 1"
							class="contact-by-email"
						>
							<b-form-textarea
								:class="{
									'form-group-error': $v.contactParams.message.$error
								}"
								id="note"
								:placeholder="$t('Other details')"
								rows="3"
								no-resize
								v-model="contactParams.message"
							></b-form-textarea>
							<div
								class="error"
								v-if="
									$v.contactParams.message.$error &&
										!$v.contactParams.message.required
								"
							>
								{{$t('Message is required')}}
							</div>
						</div>
						<div
							v-if="advertiseItem && advertiseItem.id == 2"
							class="contact-by-phone"
						>
							<div class="label-for-input">
								<div class="label">
									{{$t('A convenient time to contact you back')}}
								</div>
							</div>
							<b-dropdown class="input-choose" no-flip>
								<template v-slot:button-content>
									<span>
										{{
											periodItem
												? $t(periodItem.name)
												: $t('A convenient time to contact you back')
										}}
										<ChevronDownIcon />
									</span>
								</template>
								<b-dropdown-item
									v-for="(data, index) in contactPeriods"
									:key="index"
									@click="choosePeriods(data)"
									>{{ $t(data.name) }}</b-dropdown-item
								>
							</b-dropdown>
							<div
								class="mt-20"
								:class="{
									'form-group-error wrap-report-problems':
										$v.contactParams.message.$error
								}"
							>
								<b-form-textarea
									:class="{
										'form-group--error': $v.contactParams.message.$error
									}"
									id="other-details"
									:placeholder="$t('Other details')"
									rows="3"
									no-resize
									v-model="contactParams.message"
								></b-form-textarea>
								<div
									class="error"
									v-if="
										$v.contactParams.message.$error &&
											!$v.contactParams.message.required
									"
								>
									{{$t('Message is required')}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="wrap-btn-send">
					<b-button
						@click="conpleteContact"
						id="sendContact"
						class="btn-send"
						v-bind:class="{ disabled: !showInputContact }"
						>{{$t('send')}}</b-button
					>
				</div>
			</div>
			<div id="success-message-sent" class="success" v-if="success == true">
				<span>{{$t('Your problem has been sent to our admin team')}}</span>
				<br />
				<p>
					{{$t('We will respond to your problem as quickly as possible')}}
				</p>
				<p>
					{{$t('If you have questions about other uses Please refer to the instruction menu below')}}
				</p>
			</div>
			<div class="more-link">
				<ul class="ul-link-more text-center">
					<li>
						<router-link
							id="frequentlyAskedQuestions"
							:to="$i18nRoute({ name: 'faq' }) + '#frequently-asked-questions'"
							>{{ $t('home.frequentlyAskedQuestions') }}</router-link
						>
					</li>
					<li>
						<router-link
							id="termsOfuse"
							:to="$i18nRoute({ name: 'faq' }) + '#terms-of-use'"
							>{{ $t('home.termsOfuse') }}</router-link
						>
					</li>
					<li>
						<router-link
							id="privacyPolicy"
							:to="$i18nRoute({ name: 'faq' }) + '#privacy-policy'"
							>{{ $t('home.privacyPolicy') }}</router-link
						>
					</li>
					<li>
						<router-link
							id="listingPolicy"
							:to="$i18nRoute({ name: 'faq' }) + '#listing-policy'"
							>{{ $t('home.listingPolicy') }}</router-link
						>
					</li>
					<li>
						<router-link
							id="advertiseWithUs"
							:to="$i18nRoute({ name: 'faq' }) + '#contact-us'"
							>{{ $t('home.advertiseWithUs') }}</router-link
						>
					</li>
				</ul>
			</div>
		</template>
		<!-- MOBILE -->
		<template v-else>
			<div class="wrap" v-if="!success">
				<div class="wrap-content-mobile">
					<div class="choose-contact-topic mb-3">
						<div
							class="custom-input-mobile"
							@click="showSidebar('choose-type')"
						>
							<span class="text">{{
								topicItem ?  $t(topicItem.name) : $t('Choose a contact topic')
							}}</span>
							<ChevronDownIcon />
						</div>
					</div>
					<div
						v-if="topicItem && topicItem.id == 1"
						class="wrap-report-problems mb-3"
					>
						<b-form-textarea
							:class="{
								'form-group-error': $v.contactParams.message.$error
							}"
							id="report-problems"
							:placeholder="$t('details')"
							rows="10"
							no-resize
							v-model="contactParams.message"
						></b-form-textarea>
						<div
							class="error"
							v-if="
								$v.contactParams.message.$error &&
									!$v.contactParams.message.required
							"
						>
							{{$t('Message is required')}}
						</div>
					</div>
					<div
						v-if="topicItem && topicItem.id == 2"
						class="wrap-advertisement-contact mb-3"
					>
						<div class="label-for-input">
							<div class="label">{{$t('Ways to contact you back')}}</div>
						</div>
						<div
							class="custom-input-mobile mb-3"
							@click="showSidebar('choose-contact-back')"
						>
							<span class="text">{{
								advertiseItem
									? $t(advertiseItem.name)
									: $t('Choose a way to contact you back')
							}}</span>
							<ChevronDownIcon />
						</div>
						<div
							v-if="advertiseItem && advertiseItem.id == 1"
							class="contact-by-email mb-3"
						>
							<b-form-textarea
								:class="{
									'form-group-error': $v.contactParams.message.$error
								}"
								id="note"
								:placeholder="$t('Other details')"
								rows="3"
								no-resize
								v-model="contactParams.message"
							></b-form-textarea>
							<div
								class="error"
								v-if="
									$v.contactParams.message.$error &&
										!$v.contactParams.message.required
								"
							>
								{{$t('Message is required')}}
							</div>
						</div>
						<div
							v-if="advertiseItem && advertiseItem.id == 2"
							class="contact-by-phone mb-3"
						>
							<div class="label-for-input">
								<div class="label">
									{{$t('Choose a way to contact you back')}}
								</div>
							</div>
							<div
								class="custom-input-mobile"
								@click="showSidebar('choose-time')"
							>
								<span class="text">{{
									periodItem
										? $t(periodItem.name)
										: $t('A convenient time to contact you back')
								}}</span>
								<ChevronDownIcon />
							</div>
							<div
								class="mt-20"
								:class="{
									'form-group-error wrap-report-problems':
										$v.contactParams.message.$error
								}"
							>
								<b-form-textarea
									:class="{
										'form-group-error': $v.contactParams.message.$error
									}"
									id="other-details"
									:placeholder="$t('Other details')"
									rows="3"
									no-resize
									v-model="contactParams.message"
								></b-form-textarea>
								<div
									class="error"
									v-if="
										$v.contactParams.message.$error &&
											!$v.contactParams.message.required
									"
								>
									{{$t('Message is required')}}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="wrap-btn-send">
					<b-button
						@click="conpleteContact"
						class="btn-send"
						id="sendContact"
						v-bind:class="{ disabled: !showInputContact }"
						>{{$t('send')}}</b-button
					>
				</div>
			</div>
			<div class="success" v-if="success">
				<div>
					<p>
						{{$t('Your problem has been sent to our admin team We will respond to your problem as quickly as possible')}}
					</p>
					<p>
						{{$t('If you have questions about other uses Please refer to the instruction menu below')}}
					</p>
				</div>
			</div>
			<b-col cols="12" class="wrap-link-more">
				<ul class="ul-link-more text-center">
					<li @click="gotoFAQ">
						<router-link
							id="frequentlyAskedQuestions"
							:to="$i18nRoute({ name: 'faq' }) + '#frequently-asked-questions'"
						>
							{{ $t('home.frequentlyAskedQuestions') }}
						</router-link>
					</li>
					<li>
						<router-link
							id="termsOfuse"
							:to="$i18nRoute({ name: 'faq' }) + '#terms-of-use'"
							>{{ $t('home.termsOfuse') }}</router-link
						>
					</li>
					<li>
						<router-link
							id="privacyPolicy"
							:to="$i18nRoute({ name: 'faq' }) + '#privacy-policy'"
							>{{ $t('home.privacyPolicy') }}</router-link
						>
					</li>
					<li>
						<router-link
							id="listingPolicy"
							:to="$i18nRoute({ name: 'faq' }) + '#listing-policy'"
							>{{ $t('home.listingPolicy') }}</router-link
						>
					</li>
					<li>
						<router-link
							id="advertiseWithUs"
							:to="$i18nRoute({ name: 'ads' })"
							>{{ $t('home.advertiseWithUs') }}</router-link
						>
					</li>
					<li>
						<router-link
							id="contactUs"
							:to="$i18nRoute({ name: 'faq' }) + '#contact-us'"
							>{{ $t('home.contactUs') }}</router-link
						>
					</li>
				</ul>
			</b-col>
			<div class="custom-sidebar sidebar-1">
				<div
					class="body-sidebar"
					v-bind:class="{ show: isShow == 'choose-type' }"
				>
					<div
						v-for="(data, index) in contactTopic"
						:key="index"
						@click="chooseContactTopic(data)"
					>
						{{ $t(data.name) }}
					</div>
				</div>
				<div
					class="overlay-contact fade-in"
					v-bind:class="{ show: isShow }"
					@click="hideSidebar"
				></div>
			</div>
			<!-- <div class="custom-sidebar sidebar-2">
        <div class="body-sidebar" v-bind:class="{'show': isShow == 'choose-advertise'}">
          <div v-for="(data,index) in contactAdvertisements" :key="index" @click="chooseContactBack(data); hideSidebar()"></div>
        </div>
        <div class="overlay" v-bind:class="{'show': isShow}" @click="hideSidebar"></div>
      </div>-->
			<div class="custom-sidebar sidebar-3">
				<div
					class="body-sidebar"
					v-bind:class="{ show: isShow == 'choose-contact-back' }"
				>
					<div
						v-for="(data, index) in contactAdvertisements"
						:key="index"
						@click="
							chooseContactBack(data);
							hideSidebar();
						"
					>
						<div
							class="box-seller"
							:class="{ 'box-mail': data.id == 1, 'box-phone': data.id == 2 }"
						>
							<template v-if="data.id == 1">
								<IconMail />
							</template>
							<template v-if="data.id == 2">
								<IconPhone />
							</template>
						</div>
						<div class="text">{{ $t(data.name) }}</div>
					</div>
				</div>
				<div
					class="overlay-contact fade-in"
					v-bind:class="{ show: isShow }"
					@click="hideSidebar"
				></div>
			</div>
			<div class="custom-sidebar sidebar-4">
				<div
					class="body-sidebar"
					v-bind:class="{ show: isShow == 'choose-time' }"
				>
					<div
						v-for="(data, index) in contactPeriods"
						:key="index"
						@click="
							choosePeriods(data);
							hideSidebar();
						"
					>
						{{ $t(data.name) }}
					</div>
				</div>
				<div
					class="overlay-contact fade-in"
					v-bind:class="{ show: isShow }"
					@click="hideSidebar"
				></div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { required, minLength, between } from 'vuelidate/lib/validators';

// Icons
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import IconMail from '@/components/icons/IconMail/index';
import IconPhone from '@/components/icons/IconPhone/index';

export default {
	components: {
		ChevronDownIcon,
		IconMail,
		IconPhone,
	},
	data() {
		return {
			showInputContact: '',
			typeContactBack: '',
			selected: null,
			optionsChoosePosition: [{ value: null, text: this.$t('Choose an ad placement') }],
			isShow: '',
			topicItem: null,
			advertiseItem: null,
			reportMessage: null,
			advertiseMessage: null,
			periodItem: null,
			success: false,
			contactParams: {
				contact_topic_id: null,
				contact_advertisement_id: null,
				contact_period_id: null,
				message: ''
			}
		};
	},
	validations: {
		contactParams: {
			message: {
				required
			}
		}
	},
	mounted() {
		this.GET_DATA_USER_CONTACT_TOPIC();
	},
	computed: {
		...mapGetters('UserController', ['isMobile']),
		...mapGetters('UserContactController', [
			'contactTopic',
			'contactAdvertisements',
			'contactPeriods',
			'dataContact',
			'isSuccess'
		])
	},
	watch: {
		success: function(val) {}
	},
	methods: {
		...mapActions("FaqController", ["USER_POST_CONTACT_IN_FAQ"]),
		...mapActions('UserContactController', [
			'GET_DATA_USER_CONTACT_TOPIC',
			'GET_DATA_USER_CONTACT_ADVERTISEMENT',
			'GET_DATA_USER_CONTACT_PERIOD',
			'POST_DATA_CONTACT'
		]),
		chooseContactTopic(item, topic) {
			this.topicItem = item;
			this.contactParams.contact_topic_id = item.id;

			if (item.id == 2) {
				this.GET_DATA_USER_CONTACT_ADVERTISEMENT();
			} else {
				(this.advertiseItem = null),
					(this.reportMessage = null),
					(this.periodItem = null),
					(this.contactParams.contact_advertisement_id = null);
				this.contactParams.contact_period_id = null;
				this.contactParams.message = '';
				this.$v.$reset();
			}
			//
			this.showInputContact = item.id;
			this.hideSidebar();
		},
		chooseContactBack(item) {
			this.advertiseItem = item;
			this.contactParams.contact_advertisement_id = item.id;

			if (item.id == 2) {
				this.GET_DATA_USER_CONTACT_PERIOD();
			} else {
				(this.reportMessage = null),
					(this.periodItem = null),
					(this.contactParams.contact_period_id = null);
				this.contactParams.message = '';
				this.$v.$reset();
			}

			//
			// this.typeContactBack = typeContact;
			// this.hideSidebar();
		},
		choosePeriods(item) {
			this.periodItem = item;
			this.contactParams.contact_period_id = item.id;
		},
		showSidebar(type) {
			this.isShow = type;
		},
		hideSidebar() {
			this.isShow = '';
		},
		conpleteContact() {
			let _this=this;
			this.$v.$touch();
			if (this.$v.$invalid) {
				return;
			} else {
				let prms = { ...this.contactParams };
				Object.keys(prms).forEach(function(key) {
					if (prms[key] == null || prms[key] == '') {
						delete prms[key];
					}
				});
				
				let message=`${this.contactParams.contact_topic_id!=null?this.topicItem.name:''} ${this.contactParams.contact_advertisement_id!=null?'\n'+this.advertiseItem.name:''} ${this.contactParams.contact_period_id!=null?'\n'+this.periodItem.name:''} \nMessage: ${this.contactParams.message}`;
				
				this.USER_POST_CONTACT_IN_FAQ({from_message:message}).then(res => {
					_this.success = true;
				}).catch((err)=>{
					_this.success = false;
				});
			}
		},
		gotoFAQ() {
			this.$store.dispatch('FavouriteController/GET_FAQ', false);
		}
	}
};
</script>

<style lang="scss">
@import 'userContact.scss';
</style>
